import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SavedView } from '../../../../core/interfaces/view.model';

@Component({
  selector: 'app-update-saved-view-dialog',
  standalone: true,
  imports: [],
  templateUrl: './update-saved-view-dialog.component.html',
  styleUrl: './update-saved-view-dialog.component.css'
})
export class UpdateSavedViewDialogComponent {

  @Input() view!: SavedView;

  constructor(
    public activeModal: NgbActiveModal,
  ) {

  }

  closeModal() {
    this.activeModal.dismiss();
  }

  confirmUpdate() {
    this.updateSavedView(this.view);
    this.activeModal.close('updated');
  }

  private updateSavedView(updatedView: SavedView) {
    const saved: SavedView[] = JSON.parse(localStorage.getItem('savedViews') || '[]');

    // Update isDefault for all records
    const updatedSaved = saved.map((x: SavedView) => ({
      ...x,
      isDefault: x.id === updatedView.id
    }));

    // Move the default record to index 0
    const defaultView = updatedSaved.find(x => x.id === updatedView.id);
    const rest = updatedSaved.filter(x => x.id !== updatedView.id);
    const finalSaved = defaultView ? [defaultView, ...rest] : updatedSaved;
    localStorage.setItem('savedViews', JSON.stringify(finalSaved));
  }

}